import { Component } from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';

import lodash from 'lodash';
import Header from './Logo/Logo';
import ActionButton from './ActionButton/ActionButton';
import { UserIsAuthenticated } from 'common/permissions/application';
import { defaultInstitutionSystemPermissionsSelector } from 'common/permissions/selectors';
import AccountMenu from 'common/components/ApplicationHeader/AccountMenu';
import HelpMenu from 'common/components/ApplicationHeader/HelpMenu';
import AdminLink from 'common/components/ApplicationHeader/AdminLink';
import ChangePasswordModal from '../Login/ChangePasswordModal';
import styles from './ApplicationHeader.scss';
import { homeRouteSelector } from 'common/features/selectors';

import AddingDocumentPopover from './AddingDocumentIndicator';

class _LoggedInHeader extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false,
        };
        this.toggleModal = this.toggleModal.bind(this);
    }

    toggleModal() {
        this.setState((prevState) => ({
            isModalOpen: !prevState.isModalOpen,
        }));
    }

    render() {
        const {
            me,
            isInstitutionalAdmin,
            originUrl
        } = this.props;

        const { isModalOpen } = this.state;
        const isSso = lodash.get(me, 'isSso', false);

        return (
            <div className={styles.loggedIn} data-cy="ApplicationHeader">
                <div className={styles.actionButton} data-cy="ApplicationHeader-ActionButton">
                    <ActionButton />
                </div>

                <AddingDocumentPopover />

                <HelpMenu
                    user={me}
                />

                <AdminLink
                    isInstitutionalAdmin={isInstitutionalAdmin}
                />

                <AccountMenu
                    me={me}
                    originUrl={originUrl}
                    isSso={isSso}
                    toggleModal={this.toggleModal}
                />

                <ChangePasswordModal
                    isModalOpen={isModalOpen}
                    toggleModal={this.toggleModal}
                    email={me.email}

                />
            </div>
        );
    }
}

const LoggedInHeader = UserIsAuthenticated(_LoggedInHeader);

class ApplicationHeader extends Component {
    render() {
        const {
            me,
            isInstitutionalAdmin,
            actionButtonKind,
            originUrl,
            pageTitle,
            pathname,
            goBack,
            headerRoute
        } = this.props;

        if (!lodash.isEmpty(me)) {
            return (
                <header className={styles.header} data-cy="ApplicationHeader-ApplicationHeader">

                    <Header route={headerRoute} />

                    <LoggedInHeader
                        me={me}
                        isInstitutionalAdmin={isInstitutionalAdmin}
                        goBack={goBack}
                        originUrl={originUrl}
                        actionButtonKind={actionButtonKind}
                        pageTitle={pageTitle}
                        pathname={pathname} />
                </header>
            );
        }

        return null;
    }
}

export default connect((state, props) => {
    const me = lodash.get(state, 'me', {});
    const isInstitutionalAdmin = lodash.get(defaultInstitutionSystemPermissionsSelector(state), 'institutionalAdmin', false);
    const actionButtonKind = lodash.get(state, 'app.actionButton.kind', null);
    const originUrl = lodash.get(state, 'application.config.corsOriginUrl', null);
    const pageTitle = lodash.get(state, 'app.pageTitle', null);
    const pathname = lodash.get(state, 'routing.locationBeforeTransitions.pathname', '');
    const headerRoute = homeRouteSelector(state);

    return {
        me,
        isInstitutionalAdmin,
        actionButtonKind,
        originUrl,
        pageTitle,
        pathname,
        headerRoute,
    };
}, {
    goBack
})(ApplicationHeader);
